module.exports = __webpack_public_path__ + "img/热线.c4255c30.png";